import { render } from "./SuperiorEducationProfile.vue?vue&type=template&id=77df4e10"
import script from "./SuperiorEducationProfile.vue?vue&type=script&lang=js"
export * from "./SuperiorEducationProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__